<div class="library-card-background"></div>
<div class="library-card-container">
  <div class="library-card-v">
    <div class="library-card-name">{{ library }}</div>
    <div class="code-39 barcode0">{{ id }}</div>
    <div class="code-39 barcode1">{{ id }}</div>
    <div class="code-39 barcode0">{{ id }}</div>
    <div class="code-39-txt barcode1">{{ id }}</div>
  </div>
  <button class="btn-bottom" type="button" (click)="close()">Close</button>
</div>
